import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardHeader, Col, Row, Form, Badge } from 'reactstrap';
import InputGroup from '../../../components/cms/form/inputGroup';
import SubmitButtons from '../../../components/cms/form/submitButtons';
import MlFields from '../../../components/cms/form/mlFields';
import InputFile from '../../../components/cms/form/inputFile';
import PreviewImage from '../../../components/previewImage';
import ItemsModelService from '../../../services/projectSections.service';
import AddNewButton from '../../../components/cms/grid/addNewButton';
import Grid from '../../../components/cms/grid';
import columnTypes from '../../../components/cms/grid/columnTypes';
import InputColumn from '../../../components/cms/gridComponents/inputColumn';
import { Link } from 'react-router-dom';
import gc from '../../../components/cms/gridComponents';
import MetaDataFields from '../../../components/cms/metaDataFields';
import ValidationMessage from '../../../components/cms/form/validation/ValidationMessage';

const twoCols = { xs: 12, md: 6 };

const getItemColumns = t => [
  {
    name: 'title',
    title: t('Label'),
    filter: true,
    value: ({ item }) => (<Link to={ItemsModelService.getUpdateUrl(item.id)}>{item.title}</Link>),
  },
  {
    name: 'view_type',
    title: t('Type'),
    value: ({ item: { view_type } }) => <Badge>{ItemsModelService.getTypeTitle(view_type, t)}</Badge>,
    filter: gc.selectFilter(ItemsModelService.getTypeOptions(t)),
  },
  {
    name: 'priority',
    title: t('Priority'),
    filter: false,
    value: props => (<InputColumn {...props} />),
  },
  {
    name: 'status',
    title: t('Status'),
    value: props => (<InputColumn {...props} inputProps={{ type: 'checkbox' }} />),
    filter: gc.checkBoxFilter({ ModelService: ItemsModelService, t }),
  },
  {
    type: columnTypes.BUTTONS,
  },
];

const Project = ({
  t,
  onChange,
  onSubmit,
  errors,
  formData,
  title,
  isSubmitting,
  isSubmittingRedirect,
  onChangeMl,
  imageSrc,
  progressList,
}) => (
  <div>
    <Row>
      <Col md={12}>
        <Card>
          <CardHeader>
            <strong><i className="fa fa-star pr-2" />{title}</strong>
          </CardHeader>
          <CardBody>
            <Form onSubmit={onSubmit()}>
              <Row>
                <Col xs="12" md="9">
                  <Row>
                    <Col>
                      <InputGroup
                        name="type_id"
                        label={t('Type')}
                        type="select"
                        options={formData.projectTypes}
                        errors={errors}
                        value={formData.type_id}
                        onChange={onChange}
                        formData={formData}
                        icon="fa fa-star"
                      />
                    </Col>
                    <Col>
                      <InputGroup
                        name="platform"
                        label={t('Platform')}
                        type="select"
                        options={formData.platformsList}
                        errors={errors}
                        empty="-"
                        value={formData.platform}
                        onChange={onChange}
                        formData={formData}
                        icon="fa fa-mobile"
                      />
                    </Col>
                    <Col>
                      <InputGroup
                        name="tags"
                        label={t('Tags')}
                        onChange={onChange}
                        errors={errors}
                        type="select2"
                        formData={formData}
                        options={formData.tagsList}
                        icon="fa fa-tags"
                        multiple
                      />
                    </Col>
                    <Col>
                      <InputGroup
                        name="hashtags"
                        label={t('hashtags')}
                        type="select2"
                        options={formData.hashTagsList}
                        errors={errors}
                        onChange={onChange}
                        formData={formData}
                        icon="fa fa-hashtag"
                      />
                    </Col>
                  </Row>
                  <MlFields
                    onChange={onChangeMl}
                    formData={formData}
                    fields={({ onChange, formData }) => (
                      <div>
                        <Row>
                          <Col {...twoCols}>
                            <InputGroup
                              name="title"
                              label={t('Title')}
                              errors={errors}
                              onChange={onChange}
                              formData={formData}
                              icon="fa fa-pencil-square-o"
                            />
                            <InputGroup
                              name="permalink"
                              label={t('Permalink')}
                              errors={errors}
                              onChange={onChange}
                              formData={formData}
                              icon="fa fa-pencil-square-o"
                            />
                          </Col>
                          <Col {...twoCols}>
                            <InputGroup
                              name="url"
                              label={t('Link')}
                              errors={errors}
                              onChange={onChange}
                              formData={formData}
                              placeholder="https://"
                              icon="fa fa-external-link"
                            />
                            <InputGroup
                              name="url_title"
                              label={t('Link label')}
                              errors={errors}
                              onChange={onChange}
                              formData={formData}
                              icon="fa fa-pencil-square-o"
                            />
                          </Col>
                        </Row>
                        <InputGroup
                          name="content"
                          label={t('Teaser (appears on index page)')}
                          type="textarea"
                          errors={errors}
                          onChange={onChange}
                          formData={formData}
                        />
                        <MetaDataFields
                          onChange={onChange}
                          formData={formData}
                          errors={errors}
                        />
                      </div>
                    )}
                  />
                </Col>
                <Col xs="12" md="3">
                  <div>
                    <InputFile id="image" >
                      <PreviewImage src={imageSrc} alt="img" height="120" />
                    </InputFile>
                    {errors.image && <ValidationMessage message={errors.image.message} valid={!errors.image} />}
                  </div>
                  <InputGroup
                    name="status"
                    label={t('Status')}
                    onChange={onChange}
                    errors={errors}
                    type="checkbox"
                    checked={formData.status}
                  />
                  <InputGroup
                    name="no_index"
                    label={t('No index')}
                    onChange={onChange}
                    errors={errors}
                    type="checkbox"
                    checked={formData.no_index}
                  />
                  <InputGroup
                    name="progress_status"
                    label={t('Progress status')}
                    type="select"
                    options={progressList}
                    errors={errors}
                    onChange={onChange}
                    formData={formData}
                    icon="fa fa-check-square-o"
                  />
                  <InputGroup
                    name="published_at"
                    type="datetime"
                    label={t('Publishing date')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.published_at}
                    icon="fa fa-clock-o"
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <SubmitButtons
                    isSubmitting={isSubmitting}
                    onSubmit={onSubmit}
                    isSubmittingRedirect={isSubmittingRedirect}
                  />
                </Col>
              </Row>
            </Form>
            {formData.id && (
              <div>
                {!formData.parent_id && (
                  <Card className="mt-3">
                    <CardHeader>
                      <i className="fa fa-star-half-full" />
                      <strong>{t('Sections')}</strong>
                    </CardHeader>
                    <CardBody>
                      <div className="mb-2">
                        <AddNewButton to={ItemsModelService.getItemCreateUrl(formData.id)} icon="fa fa-plus" text={t('Add item')} />
                      </div>
                      <Grid
                        id="subwidgets"
                        service={ItemsModelService}
                        initCriteria={{ project_id: formData.id }}
                        columns={getItemColumns(t)}
                      />
                    </CardBody>
                  </Card>
                )}
              </div>
            )}
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
);

Project.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isSubmittingRedirect: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

export default Project;



// WEBPACK FOOTER //
// ./src/views/projects/project/Project.jsx